import React, { ReactElement, useEffect } from 'react';
import { useCookies } from 'react-cookie';

import { useAuth } from 'features/auth';
import { Page, Loading } from 'components';
import { createUrl } from 'app/utils';

const ResetView = (): ReactElement => {
  const { clearAuth } = useAuth();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, setCookie, removeCookie] = useCookies(['token', 'autoDiscover']);

  useEffect(() => {
    clearAuth();

    removeCookie('token', {
      path: '/',
      domain: window.location.hostname,
    });

    removeCookie('autoDiscover', {
      path: '/',
      domain: window.location.hostname,
    });

    window.location.href = createUrl('dashboard');
  }, []);

  return (
    <Page title="Reset">
      <Loading label="Aguarde..." />
    </Page>
  );
};

export default ResetView;
